module.exports = __webpack_public_path__ + "images/dir-small-empty-20840423859854a696871b65927bba80.png";